// Theme: crt-soft
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'crt-soft',
  name: 'CRT Soft',
  tagline: 'CRT',
  description: 'Monitor antigo. Glow minimo e scanline leve.',
  category: 'retro-memory',
  tier: 'legendary',
  basePrice: 5250,
  swatches: ['#030303', '#4ade80', '#050505', '#86efac'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '0px',
      '--shadow-card': 'none',
      '--shadow-card-active': '0 0 15px color-mix(in srgb, var(--primary) 65%, transparent), inset 0 0 8px color-mix(in srgb, var(--primary) 45%, transparent)'
    },
    shellClasses: 'font-mono theme-crt'
  },
  colorVars: {
    '--accent': '#4ade80',
    '--accent-foreground': '#030303',
    '--background': '#030303',
    '--border': 'rgba(74, 222, 128, 0.18)',
    '--card': '#050505',
    '--card-border-active': 'rgba(74, 222, 128, 0.35)',
    '--card-completed': '#041108',
    '--card-foreground': '#86efac',
    '--card-glow': 'rgba(74, 222, 128, 0.40)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#86efac',
    '--hold-fill': '#4ade80',
    '--input': 'rgba(74, 222, 128, 0.18)',
    '--modal-bg': '#030303',
    '--modal-border': 'rgba(74, 222, 128, 0.18)',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#040404',
    '--muted-foreground': 'rgba(74, 222, 128, 0.70)',
    '--nav-active': '#4ade80',
    '--nav-bg': 'rgba(0, 0, 0, 0.60)',
    '--popover': '#050505',
    '--popover-foreground': '#86efac',
    '--primary': '#4ade80',
    '--primary-foreground': '#030303',
    '--ring': '#4ade80',
    '--secondary': '#040404',
    '--secondary-foreground': '#86efac',
    '--streak': '#fb923c',
    '--success': '#4ade80',
    '--success-foreground': '#030303',
    '--xp': '#4ade80',
    '--xp-bg': 'rgba(74, 222, 128, 0.10)'
  },
  resolvedVars: {
    '--accent': '#4ade80',
    '--accent-foreground': '#030303',
    '--accent-foreground-hsl': '0 0% 1%',
    '--accent-foreground-oklch': 'from #030303 l c h',
    '--accent-hsl': '142 69% 58%',
    '--accent-oklch': 'from #4ade80 l c h',
    '--background': '#030303',
    '--background-hsl': '0 0% 1%',
    '--background-oklch': 'from #030303 l c h',
    '--border': 'rgba(74, 222, 128, 0.18)',
    '--border-w': '1px',
    '--card': '#050505',
    '--card-border-active': 'rgba(74, 222, 128, 0.35)',
    '--card-completed': '#041108',
    '--card-completed-hsl': '138 62% 4%',
    '--card-completed-oklch': 'from #041108 l c h',
    '--card-foreground': '#86efac',
    '--card-foreground-hsl': '142 77% 73%',
    '--card-foreground-oklch': 'from #86efac l c h',
    '--card-glow': 'rgba(74, 222, 128, 0.40)',
    '--card-hsl': '0 0% 2%',
    '--card-oklch': 'from #050505 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#86efac',
    '--foreground-hsl': '142 77% 73%',
    '--foreground-oklch': 'from #86efac l c h',
    '--hold-fill': '#4ade80',
    '--hold-fill-hsl': '142 69% 58%',
    '--hold-fill-oklch': 'from #4ade80 l c h',
    '--input': 'rgba(74, 222, 128, 0.18)',
    '--modal-bg': '#030303',
    '--modal-bg-hsl': '0 0% 1%',
    '--modal-bg-oklch': 'from #030303 l c h',
    '--modal-border': 'rgba(74, 222, 128, 0.18)',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#040404',
    '--muted-foreground': 'rgba(74, 222, 128, 0.70)',
    '--muted-hsl': '0 0% 2%',
    '--muted-oklch': 'from #040404 l c h',
    '--nav-active': '#4ade80',
    '--nav-active-hsl': '142 69% 58%',
    '--nav-active-oklch': 'from #4ade80 l c h',
    '--nav-bg': 'rgba(0, 0, 0, 0.60)',
    '--popover': '#050505',
    '--popover-foreground': '#86efac',
    '--popover-foreground-hsl': '142 77% 73%',
    '--popover-foreground-oklch': 'from #86efac l c h',
    '--popover-hsl': '0 0% 2%',
    '--popover-oklch': 'from #050505 l c h',
    '--primary': '#4ade80',
    '--primary-foreground': '#030303',
    '--primary-foreground-hsl': '0 0% 1%',
    '--primary-foreground-oklch': 'from #030303 l c h',
    '--primary-hsl': '142 69% 58%',
    '--primary-oklch': 'from #4ade80 l c h',
    '--radius': '0px',
    '--ring': '#4ade80',
    '--ring-hsl': '142 69% 58%',
    '--ring-oklch': 'from #4ade80 l c h',
    '--secondary': '#040404',
    '--secondary-foreground': '#86efac',
    '--secondary-foreground-hsl': '142 77% 73%',
    '--secondary-foreground-oklch': 'from #86efac l c h',
    '--secondary-hsl': '0 0% 2%',
    '--secondary-oklch': 'from #040404 l c h',
    '--shadow-card': 'none',
    '--shadow-card-active': '0 0 15px color-mix(in srgb, var(--primary) 65%, transparent), inset 0 0 8px color-mix(in srgb, var(--primary) 45%, transparent)',
    '--streak': '#fb923c',
    '--streak-hsl': '27 96% 61%',
    '--streak-oklch': 'from #fb923c l c h',
    '--success': '#4ade80',
    '--success-foreground': '#030303',
    '--success-foreground-hsl': '0 0% 1%',
    '--success-foreground-oklch': 'from #030303 l c h',
    '--success-hsl': '142 69% 58%',
    '--success-oklch': 'from #4ade80 l c h',
    '--tint-primary-subtle': 'hsla(142 69% 58% / 0.15)',
    '--xp': '#4ade80',
    '--xp-bg': 'rgba(74, 222, 128, 0.10)',
    '--xp-hsl': '142 69% 58%',
    '--xp-oklch': 'from #4ade80 l c h'
  }
}
